import { ChangeDetectionStrategy, ChangeDetectorRef, Component, forwardRef, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-toggle-switch',
    templateUrl: './toggle-switch.component.html',
    styleUrls: ['./toggle-switch.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => ToggleSwitchComponent),
            multi: true
        }
    ],
    standalone: false
})
export class ToggleSwitchComponent implements ControlValueAccessor, OnInit {


    _onIcon: any = ['fas', 'check'];

    @Input()
    public get onIcon(): any {
        if (this._onIcon === undefined) { return ['fas', 'check']; };

        return this._onIcon;
    }

    public set onIcon(value: any) {
        this._onIcon = value;
    }


    _offIcon: any = ['fas', 'times'];

    @Input()
    public get offIcon(): any {
        if (this._offIcon === undefined) { return ['fas', 'times']; }

        return this._offIcon;
    }

    public set offIcon(value: any) {
        this._offIcon = value;
    }

    @Input() label: string = '';

    onChange: any = () => { };
    onTouch: any = () => { };
    _value: boolean;

    @Input()
    set value(val) {
        if (val !== undefined && this._value !== val) {
            this._value = val;
            this.onChange(val);
            this.onTouch(val);
        }
    }
    get value(): boolean {
        return this._value;
    }


    writeValue(value: any): void {
        this.value = value;
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    setDisabledState?(isDisabled: boolean): void {

    }

    constructor(private cd: ChangeDetectorRef) { }

    ngOnInit(): void {
        setInterval(() => {
            this.cd.detectChanges();
        }, 1000);
    }


}
